// extracted by mini-css-extract-plugin
module.exports = {"iconButton":"IconButton_iconButton__24OgC","iconButtonLight":"IconButton_iconButtonLight__1G03s","iconButtonDark":"IconButton_iconButtonDark__2ga4M"};